// extracted by mini-css-extract-plugin
module.exports = {"shoe":"shoe_shoe__2eXiK","img":"shoe_img__2jfsx","name":"shoe_name__1ml0s","cart":"shoe_cart__1Q2cr"};